module.exports = __webpack_public_path__ + "static/media/castleSmall@3x.9f729052.png";